
export const emnus = {
    commodityType: {
        desc: "商品类型",
        options: [
            {
                value: '1',
                label: '一件代发', //'一件代发商品'
            }, {
                value: '2',
                label: 'OEM/ODM', //'OEM商品'
            }, 
            // {
            //     value: '3',
            //     label: '自营商品'
            // }, 
            {
                value: '4',
                label: '线下采集', // '原材料辅材'
            },
            // {
            //     value: '10',
            //     label: '贸易商品'
            // },
        ]
    },
    approveStatus: {
        desc: "审核状态",
        options: [
            {
                value: 'WAITING_APPROVE',
                label: '待审核'
            }, {
                value: 'AGREEMENT',
                label: '审核通过'
            }, {
                value: 'REFUSED',
                label: '审核不通过'
            }
        ]
    },
    transferStatus: {
        desc: "交易状态",
        options: [
            {
                value: 'CREATED',
                label: '已发起'
            },
            {
                value: 'DEALING',
                label: '处理中'
            }, {
                value: 'SUCCESS',
                label: '交易成功'
            }, {
                value: 'FAILED',
                label: '交易失败'
            }
        ]
    },
    transferStatusColor: {
        desc: "交易状态颜色",
        options: [
            {
                value: 'CREATED',
                label: 'geekblue',
            }, {
                value: 'DEALING',
                label: 'purple',
            }, {
                value: 'SUCCESS',
                label: 'green',
            }, {
                value: 'FAILED',
                label: 'red',
            }
        ]
    },
    transferDirection: {
        desc: "交易方向",
        options: [
            {
                value: 'IN',
                label: '收入'
            }, {
                value: 'OUT',
                label: '支出'
            }
        ]
    },
    transferBusinessType: {
        desc: "交易业务类型",
        options: [
            {
                value: 'RECHARGE_OFFLINE',
                label: '线下充值'
            }, {
                value: 'PAY_ORDER',
                label: '订单支付'
            }
        ]
    },
    userType: {
        desc: "用户类型",
        options: [
            {
                value: 'ADMIN',
                label: '管理员'
            }, {
                value: 'DELIVERY',
                label: '供应商'
            }, {
                value: 'PLATFORM',
                label: '平台'
            }, {
                value: 'CUSTOMER',
                label: '客户'
            }
        ]
    },
    gender: {
        desc: "用户性别",
        options: [
            {
                value: 'MALE',
                label: '男'
            }, {
                value: 'FEMALE',
                label: '女'
            }
        ]
    },
    enableFlag: {
        desc: "启用状态",
        options: [
            {
                value: '1',
                label: '已启用'
            }, {
                value: '0',
                label: '已停用'
            }
        ]
    },
    authFlag: {
        desc: "授权状态",
        options: [
            {
                value: '1',
                label: '已授权'
            }, {
                value: '0',
                label: '未授权'
            }
        ]
    },
    platform: {
        desc: "平台",
        options: [
            {
                value: 2,
                label: "lazada"
            },
           
            {
                value: 11,
                label: "shopee"
            },
            {
                value: 22,
                label: "TikTok"
            },
            {
                value: 62,
                label: "shopee预先履约"
            }
        ]
    },
    platformOrder: {
        desc: "平台",
        options: [
            {
                value: 11,
                label: "shopee"
            },
            {
                value: 22,
                label: "TikTok"
            },
        ]
    },
    payChannel: {
        desc: "支付渠道",
        options: [
            {
                value: "BALANCE_PAY",
                label: "余额支付"
            },
            {
                value: "ALI_PAY",
                label: "支付宝"
            },
            {
                value: "WECHAT_PAY",
                label: "微信"
            },
            {
                value: "UNION_PAY",
                label: "银联"
            }
        ]
    },
    payStatus: {
        desc: "支付状态",
        options: [
            {
                value: "UNPAY",
                label: "待支付"
            }, {
                value: "PAYING",
                label: "支付中"
            },
            {
                value: "PAID",
                label: "已支付"
            },
            {
                value: "FAILED",
                label: "支付失败"
            }, {
                value: "CANCEL",
                label: "取消支付"
            },
            {
                value: "NO_PAY",
                label: "无需支付"
            }
        ]
    },
    payStatusColor: {
        desc: "支付状态颜色",
        options: [
            {
                value: "UNPAY",
                label: "gold"
            },
            {
                value: "PAYING",
                label: "purple"
            },
            {
                value: "PAID",
                label: "green"
            },
            {
                value: "FAILED",
                label: "red"
            }, {
                value: "CANCEL",
                label: "geekblue"
            }, {
                value: "NO_PAY",
                label: "green"
            }
        ]
    },
     ProductCategory: {
        desc: "产品类别",
        options: [
            {
                value: "CLOTHING",
                label: "服装"
            },
            {
                value: "ELECTRONICS",
                label: "电子产品"
            },
            {
                value: "家居用品",
                label: "HOME_GOODS"
            },
            {
                value: "MECHANICAL_EQUIPMENT",
                label: "机械设备"
            }, {
                value: "FOOD_BEVERAGE",
                label: "食品饮料"
            }, {
                value: "CHEMICAL_RAW_MATERIALS",
                label: "化工原料"
            }, {
                value: "OTHER",
                label: "其他"
            }
        ]
    },
    RequirementType: {
        desc: "需求类型",
        options: [
            {
                value: 1,
                label: "采购需求"
            },
            {
                value: 2,
                label: "供应信息"
            },
            {
                value: 3,
                label: "商机线索"
            }
        ]
    },
    businessStatus: {
        desc: "商机状态",
        options: [
            {
                value: 'NEWLY_RELEASED',
                label: "新发布"
            },
            {
                value: 'UNDERWAY',
                label: "进行中"
            },
            {
                value: 'COOPERATED',
                label: "已合作"
            }
        ]
    },
    urgencyLevel: {
        desc: "紧急度等级",
        options: [
            {
                value: 3,
                label: "紧急"
            },
            {
                value: 2,
                label: "一般 "
            },
            {
                value: 1,
                label: "长期"
            }
        ]
    },
}